import smartSolveApi from './instances/smartsolve';

export const getEntitiesList = async () => {
  try {
    const response = await smartSolveApi.post('/entity/getentitylist', {});
    return response.data;
  } catch (e) {
    throw new Error(`getEntitiesList() failed: ${e}`);
  }
};
